// store/admin/certificates/store/_actionTypes.js

// =====================================================
// CERTIFICATES LIST
// =====================================================
export const FETCH_CERTIFICATES_REQUEST = 'ADMIN_FETCH_CERTIFICATES_REQUEST';
export const FETCH_CERTIFICATES_SUCCESS = 'ADMIN_FETCH_CERTIFICATES_SUCCESS';
export const FETCH_CERTIFICATES_FAILURE = 'ADMIN_FETCH_CERTIFICATES_FAILURE';

// =====================================================
// CERTIFICATE BY ID
// =====================================================
export const FETCH_CERTIFICATE_BY_ID_REQUEST = 'FETCH_CERTIFICATE_BY_ID_REQUEST';
export const FETCH_CERTIFICATE_BY_ID_SUCCESS = 'FETCH_CERTIFICATE_BY_ID_SUCCESS';
export const FETCH_CERTIFICATE_BY_ID_FAILURE = 'FETCH_CERTIFICATE_BY_ID_FAILURE';

// =====================================================
// PENDING APPROVALS
// =====================================================
export const FETCH_PENDING_APPROVALS_REQUEST = 'FETCH_PENDING_APPROVALS_REQUEST';
export const FETCH_PENDING_APPROVALS_SUCCESS = 'FETCH_PENDING_APPROVALS_SUCCESS';
export const FETCH_PENDING_APPROVALS_FAILURE = 'FETCH_PENDING_APPROVALS_FAILURE';

// =====================================================
// CERTIFICATE STATS
// =====================================================
export const FETCH_CERTIFICATE_STATS_REQUEST = 'FETCH_CERTIFICATE_STATS_REQUEST';
export const FETCH_CERTIFICATE_STATS_SUCCESS = 'FETCH_CERTIFICATE_STATS_SUCCESS';
export const FETCH_CERTIFICATE_STATS_FAILURE = 'FETCH_CERTIFICATE_STATS_FAILURE';

// =====================================================
// APPROVE CERTIFICATE (Single)
// =====================================================
export const APPROVE_CERTIFICATE_REQUEST = 'APPROVE_CERTIFICATE_REQUEST';
export const APPROVE_CERTIFICATE_SUCCESS = 'APPROVE_CERTIFICATE_SUCCESS';
export const APPROVE_CERTIFICATE_FAILURE = 'APPROVE_CERTIFICATE_FAILURE';

// =====================================================
// ISSUE MANUAL CERTIFICATE
// =====================================================
export const ISSUE_MANUAL_CERTIFICATE_REQUEST = 'ISSUE_MANUAL_CERTIFICATE_REQUEST';
export const ISSUE_MANUAL_CERTIFICATE_SUCCESS = 'ISSUE_MANUAL_CERTIFICATE_SUCCESS';
export const ISSUE_MANUAL_CERTIFICATE_FAILURE = 'ISSUE_MANUAL_CERTIFICATE_FAILURE';
export const CLEAR_ISSUE_MANUAL_RESULT = 'CLEAR_ISSUE_MANUAL_RESULT';

// =====================================================
// BULK APPROVE CERTIFICATES
// =====================================================
export const BULK_APPROVE_CERTIFICATES_REQUEST = 'BULK_APPROVE_CERTIFICATES_REQUEST';
export const BULK_APPROVE_CERTIFICATES_SUCCESS = 'BULK_APPROVE_CERTIFICATES_SUCCESS';
export const BULK_APPROVE_CERTIFICATES_FAILURE = 'BULK_APPROVE_CERTIFICATES_FAILURE';

// =====================================================
// REVOKE CERTIFICATE
// =====================================================
export const REVOKE_CERTIFICATE_REQUEST = 'REVOKE_CERTIFICATE_REQUEST';
export const REVOKE_CERTIFICATE_SUCCESS = 'REVOKE_CERTIFICATE_SUCCESS';
export const REVOKE_CERTIFICATE_FAILURE = 'REVOKE_CERTIFICATE_FAILURE';

// =====================================================
// VERIFY CERTIFICATE
// =====================================================
export const VERIFY_CERTIFICATE_REQUEST = 'VERIFY_CERTIFICATE_REQUEST';
export const VERIFY_CERTIFICATE_SUCCESS = 'VERIFY_CERTIFICATE_SUCCESS';
export const VERIFY_CERTIFICATE_FAILURE = 'VERIFY_CERTIFICATE_FAILURE';

// =====================================================
// COLLEGES & COURSES (Dropdowns)
// =====================================================
export const FETCH_COLLEGES_REQUEST = 'FETCH_COLLEGES_REQUEST';
export const FETCH_COLLEGES_SUCCESS = 'FETCH_COLLEGES_SUCCESS';
export const FETCH_COLLEGES_FAILURE = 'FETCH_COLLEGES_FAILURE';

export const FETCH_COURSES_REQUEST = 'certificate/FETCH_COURSES_REQUEST';
export const FETCH_COURSES_SUCCESS = 'certificate/FETCH_COURSES_SUCCESS';
export const FETCH_COURSES_FAILURE = 'certificate/FETCH_COURSES_FAILURE';

// =====================================================
// UI STATE
// =====================================================
export const SET_SELECTED_COLLEGE = 'SET_SELECTED_COLLEGE';
export const SET_SELECTED_COURSE = 'SET_SELECTED_COURSE';
export const CLEAR_CERTIFICATE_ERROR = 'CLEAR_CERTIFICATE_ERROR';
export const RESET_CERTIFICATE_STATE = 'RESET_CERTIFICATE_STATE';